import { InputProps } from '@chakra-ui/react';
import { useColorModeValue } from '@chakra-ui/react';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { FormInputMeta } from '../../types/FormMetaType';
import CustomInputCheckBox from './CustomInputCheckBox';
import CustomInputSelect from './CustomInputSelect';
import CustomTextArea from './CustomTextArea';
import CustomTextInput from './CustomTextInput';

export enum INPUT_TYPE {
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  TEXTAREA = 'textarea',
}

type Props = {
  meta: FormInputMeta,
  register?: any,
  hasError?: any,
  showCheckboxLabel?: boolean,
} & InputProps;

export default function CustomInput({
  meta,
  register,
  hasError,
  showCheckboxLabel,
  ...rest
}: Props) {
  if (meta.type === INPUT_TYPE.SELECT) {
    return (
      <CustomInputSelect meta={meta} register={register} hasError={hasError} />
    );
  }

  if (meta.type === INPUT_TYPE.TEXTAREA) {
    return (
      <CustomTextArea meta={meta} register={register} hasError={hasError} />
    );
  }

  if (meta.type === INPUT_TYPE.CHECKBOX) {
    return (
      <CustomInputCheckBox meta={meta} register={register} hasError={hasError}>
        {showCheckboxLabel !== false && <CC.Text ml="2">{meta.label}</CC.Text>}
      </CustomInputCheckBox>
    );
  }

  if (meta.type === INPUT_TYPE.RADIO && meta.options) {
    return (
      <CC.RadioGroup defaultValue="2">
        <CC.Stack spacing={5} direction="row" pt="2">
          {meta.options.map((opt, i) => (
            <CC.Radio key={i} value={opt.value}>
              {opt.label}
            </CC.Radio>
          ))}
        </CC.Stack>
      </CC.RadioGroup>
    );
  }

  if (meta.type === INPUT_TYPE.TEXTAREA) {
    return (
      <CustomTextArea meta={meta} register={register} hasError={hasError} />
    );
  }

  return (
    <CustomTextInput
      {...rest}
      meta={meta}
      register={register}
      hasError={hasError}
    />
  );
}
